module.exports = __webpack_public_path__ + "static/media/trash-2-white.227548f2.svg";